export enum ProfileDataDiscriminator {
    AnonymousProfile = 'AnonymousProfile',
    EnterpriseProfile = 'EnterpriseProfile',
    IntegrationProfile = 'IntegrationProfile',
    JobProfile = 'JobProfile',
    PersonalProfile = 'PersonalProfile',
    PlatformProfile = 'PlatformProfile',
    SystemProfile = 'SystemProfile',
}
